<template>
  <tiles :items="tiles" class="quiz-view__tiles">
    <template v-slot:default="props">
      <TileItem @click="$emit('tile-click', props.item.id, props.item.nextGroupID)">
        <template v-slot:image v-if="!isMobile">
          <media renderAs="div" :src="props.item.imageURL" />
        </template>
        <template v-slot:bottom>
          <custom-button :caption="props.item.text" :uppercase="true"></custom-button>
        </template>
      </TileItem>
    </template>
  </tiles>
</template>
<script>
import Tiles from "../components/Tiles/Tiles.vue";
import TileItem from "../components/Tiles/TileItem.vue";
import Media from "../components/Media.vue";
import Button from "../components/Button.vue";

import { isMobile } from "../mixins/is-mobile";

export default {
  name: "TilesQuestion",
  components: {
    Tiles,
    TileItem,
    Media,
    CustomButton: Button
  },
  mixins: [isMobile],
  props: {
    tiles: {
      type: Array,
      required: true
    }
  }
};
</script>